import React from 'react';
import PropTypes from 'prop-types';

import Config from '@/config';

const EmbedCode = ({ ltc_quoter }) => {
  return (
    <div>
      <p style={{ fontFamily: 'monospace', lineHeight: '1.8em', fontSize: '12px' }}>
        {`<link href='${Config.LTC_URL}@css/reset.css' rel='stylesheet' type='text/css'>`}
        <br />
        {"<script type='text/javascript'>"}
        <br />
        <span
          style={{ marginLeft: '20px' }}
        >{`window.IXN_LTC_CONFIG = { id: '${ltc_quoter.id}' };`}</span>
        <br />
        {'</script>'}
        <br />
        {"<div id='ltc-quoter'></div>"}
        <br />
        {`<script type='text/javascript' src='${Config.LTC_URL}js/ltc_quoter.widget.js'></script>`}
      </p>
    </div>
  );
};

EmbedCode.propTypes = {
  ltc_quoter: PropTypes.object
};

export default EmbedCode;
